// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-tab-detail {
  display: block;
  margin: var(--wm-feature-details-margin);
}
wm-tab-detail .webmapp-pageroute-tabdetail-item-live {
  --inner-padding-bottom: 10px;
  --inner-padding-top: 10px;
}
wm-tab-detail .webmapp-pageroute-tabdetail-item-live::part(native) {
  align-items: flex-start;
}
wm-tab-detail .webmapp-pageroute-tabdetail-item-live ion-label.webmapp-pageroute-tabdetail-label {
  margin-top: 0 !important;
}
wm-tab-detail .webmapp-pageroute-tabdetail-end-stack {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  padding-inline-end: 4px;
}
wm-tab-detail .webmapp-pageroute-tabdetail-chart {
  text-align: center;
  width: 100%;
  display: block;
  padding: 0 10px;
}
wm-tab-detail .webmapp-title {
  font-weight: var(--wm-feature-details-title-font-weight);
  font-size: var(--wm-feature-details-title-font-size);
  color: var(--wm-feature-details-title-color);
  font-family: var(--wm-feature-details-title-font-family);
}
wm-tab-detail .webmapp-pageroute-tabdetail-label {
  color: var(--wm-color-dark);
}
wm-tab-detail .webmapp-pageroute-tabdetail-icon {
  color: var(--wm-color-primary);
  padding: 0 5px;
}
wm-tab-detail .webmapp-pageroute-tabdetail-value {
  color: var(--wm-color-dark);
  font-weight: var(--wm-font-weight-bold);
  font-size: 0.6875rem;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/tab-detail/tab-detail.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,wCAAA;AACF;AACE;EACE,4BAAA;EACA,yBAAA;AACJ;AACI;EACE,uBAAA;AACN;AAEI;EAIE,wBAAA;AAHN;AAOE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;EACA,uBAAA;AALJ;AAQE;EAEE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AAPJ;AASE;EACE,wDAAA;EACA,oDAAA;EACA,4CAAA;EACA,wDAAA;AAPJ;AASE;EACE,2BAAA;AAPJ;AAUE;EACE,8BAAA;EACA,cAAA;AARJ;AAWE;EACE,2BAAA;EACA,uCAAA;EACA,oBAAA;AATJ","sourcesContent":["wm-tab-detail {\n  display: block;\n  margin: var(--wm-feature-details-margin);\n\n  .webmapp-pageroute-tabdetail-item-live {\n    --inner-padding-bottom: 10px;\n    --inner-padding-top: 10px;\n\n    &::part(native) {\n      align-items: flex-start;\n    }\n\n    ion-label.webmapp-pageroute-tabdetail-label {\n      // ion-label ha un margin-top di default (~10px) pensato per l'allineamento centrato\n      // di ion-item: con align-items:flex-start va azzerato, altrimenti l'etichetta resta\n      // visibilmente più in basso del valore sulla stessa riga\n      margin-top: 0 !important;\n    }\n  }\n\n  .webmapp-pageroute-tabdetail-end-stack {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 4px;\n    padding-inline-end: 4px;\n  }\n\n  .webmapp-pageroute-tabdetail-chart {\n    // height: 200px;\n    text-align: center;\n    width: 100%;\n    display: block;\n    padding: 0 10px;\n  }\n  .webmapp-title {\n    font-weight: var(--wm-feature-details-title-font-weight);\n    font-size: var(--wm-feature-details-title-font-size);\n    color: var(--wm-feature-details-title-color);\n    font-family: var(--wm-feature-details-title-font-family);\n  }\n  .webmapp-pageroute-tabdetail-label {\n    color: var(--wm-color-dark);\n  }\n\n  .webmapp-pageroute-tabdetail-icon {\n    color: var(--wm-color-primary);\n    padding: 0 5px;\n  }\n\n  .webmapp-pageroute-tabdetail-value {\n    color: var(--wm-color-dark);\n    font-weight: var(--wm-font-weight-bold);\n    font-size: 0.6875rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
